import BaseInputComponent from "basecomponents/BaseInputComponent";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { InputField, TextArea } from "../components/form";
import { SmallSpinner } from "../components/loaders";

import {
  getClientProfile,
  updateClientProfile,
} from "../actions/profileActions";
import { showPopUp, showModal } from "../utils/domUtils";

import UpdatePasswordModal from "modals/UpdatePasswordModal";

import { IProfile } from "../interfaces/IClient";

class ClientDashboardAccount extends BaseInputComponent {
  state = {
    name: "",
    email: "",
    phone: "",
    address: "",
    user: "",
    code: "",
    errors: {},
  };

  idmodal_update_password = "modal_update_password";

  componentDidMount() {
    // @ts-ignore
    this.props.getClientProfile((success) => {
      if (success) {
        this.configStateFromProps();
      }
    });
  }

  static getDerivedStateFromProps(nextProps) {
    let newState = {
      errors: null,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }
    return newState.changed ? newState : null;
  }

  isLoading(): boolean {
    // @ts-ignore
    return this.props.profile.loading === true;
  }

  configStateFromProps() {
    // @ts-ignore
    const profile: IProfile = this.props.profile.data;
    if (!profile) return;

    this.setState({
      name: profile.name,
      email: profile.email,
      phone: profile.phone || "",
      address: profile.address || "",
      user: profile.user || "",
      code: profile.code,
    });
  }

  onUpdateProfile = () => {
    const { name, phone, address, user } = this.state;
    // @ts-ignore
    this.props.updateClientProfile(
      {
        name,
        phone,
        address,
        user,
      },
      (success) => {
        if (Object.keys(this.state.errors).length > 0) return;
        const popup = {
          title: "Perfil actualizado correctamente!",
          message: "",
        };
        if (!success) {
          popup.title = "Ocurrio un evento inesperado";
          popup.message =
            "Sentimos que no fuera posible actualizar el perfil, por favor intenta en unos minutos";
        }
        showPopUp(popup.title, popup.message);
        if (success) {
          this.configStateFromProps();
        }
      }
    );
  };

  getForm = () => {
    const { name, email, phone, user, address, code, errors } = this.state;
    const loading = this.isLoading();
    return (
      <>
        <div className="form-row">
          <InputField
            id="name"
            name="name"
            label="Nombre"
            extraClass="col-6"
            value={name}
            onChange={this.onChangeTextInput}
            disabled={loading}
            error={errors}
          />

          <InputField
            id="code"
            label="Codigo"
            extraClass="col-6"
            value={code}
            disabled={true}
            onChange={this.onChangeDisabled}
          />
        </div>

        <div className="form-row">
          <InputField
            id="phone"
            name="phone"
            label="Telefono"
            extraClass="col-6"
            value={phone}
            onChange={this.onChangeTextInput}
            disabled={loading}
            error={errors}
          />

          <InputField
            id="user"
            name="user"
            label="Usuario"
            extraClass="col-6"
            value={user}
            onChange={this.onChangeTextInput}
            disabled={loading}
            error={errors}
          />
        </div>

        <InputField
          id="email"
          name="email"
          label="Correo"
          type="email"
          value={email}
          disabled={true}
          onChange={this.onChangeDisabled}
        />

        <TextArea
          id="address"
          name="address"
          value={address}
          label="Direcci&oacute;n de envio (Opcional)"
          disabled={loading}
          onChange={this.onChangeTextInput}
        />

        {loading && <SmallSpinner center={true} />}
      </>
    );
  };

  render() {
    return (
      <>
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <div className="card-title">Perfil</div>
              </div>
              <div className="card-body">{this.getForm()}</div>
              <div className="card-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    showModal(this.idmodal_update_password);
                  }}
                >
                  Cambiar clave
                </button>
                <button
                  className="btn btn-primary float-right"
                  onClick={this.onUpdateProfile}
                >
                  Actualizar
                </button>
              </div>
            </div>
          </div>
        </div>

        <UpdatePasswordModal modal_id={this.idmodal_update_password} />
      </>
    );
  }
}

// @ts-ignore
ClientDashboardAccount.propTypes = {
  profile: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  getClientProfile: PropTypes.func.isRequired,
  updateClientProfile: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  profile: state.profile,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getClientProfile,
  updateClientProfile,
})(ClientDashboardAccount);
